import { LoggedOutComponent } from '../components/logged-out/logged-out.component';
import { AuthCallbackComponent } from '../components/auth-callback/auth-callback.component';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MissingPermissionsComponent } from '../components/missing-permissions/missing-permissions.component';
import { UnauthenticatedLandingComponent } from '../components/unauthenticated-landing/unauthenticated-landing.component';

const authRoutes = [
  {
    path: 'logged-out',
    component: LoggedOutComponent
  },
  {
    path: 'access-denied',
    component: MissingPermissionsComponent,
    data: { title: 'Access Denied' }
  },
  {
    path: 'authenticate',
    component: AuthCallbackComponent
  },
  {
    path: 'unauthenticated',
    component: UnauthenticatedLandingComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(authRoutes)],
  exports: [RouterModule]
})
export class AuthRoutingModule {}
